import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeviceDetectionService } from '../../../../../shared/services/device-detection.service';
// @ts-ignore
declare var L: any;
import { NegativaService } from '../../../services/negativa.service';
import { UsuarioService } from '../../../services/usuario.service';
import { ServicoService } from '../../../services/servico.service';
import { environment } from '../../../../../../environments/environment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


@Component({
  selector: 'app-servicos-negativa',
  standalone: false,
  templateUrl: './servicos-negativa.component.html',
  styleUrl: './servicos-negativa.component.css'
  ,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicosNegativaComponent implements OnInit {
  negativas: any[] = [];
  negativasFiltradas: any[] = [];
  negativaDetalhes: any | null = null;
  usuariosFiltro: { usuarioId: string, nome: string }[] = [];
  filtroUsuarioId: string = '';
  filtroDataInicio: string = '';
  filtroDataFim: string = '';
  // Toggle to show/hide advanced filters (added to match servicos template)
  showFiltros: boolean = false;
  // Filter for status (optional)
  filtroStatus: string = '';
  // Additional filters mirrored from servicos component
  filtroNumeroOrdem: number | null = null;
  filtroMatricula: string = '';
  filtroNomeConsumidor: string = '';
  filtroCpf: string = '';
  filtroCnpj: string = '';
  filtroCep: string = '';
  filtroLogradouro: string = '';
  filtroBairro: string = '';
  filtroCidade: string = '';
  filtroEstado: string = '';
  filtroNumero: string = '';
  filtroNumeroVistoria: string = '';
  carregando = false;
  erro: string | null = null;
  paginaAtual = 1;
  tamanhoPagina = 50;
  totalItens = 0;
  totalPaginas = 1;
  mostrarModalFoto = false;
  fotoSelecionada = '';
  // store rotation degrees for photos (keyed by image URL)
  private photoRotations: { [key: string]: number } = {};
  // Rotation for the enlarged photo modal (degrees)
  rotacaoFoto = 0;
  Math = Math;

  constructor(
    public negativaService: NegativaService,
    public usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    public servicoService: ServicoService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private deviceService: DeviceDetectionService,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    // Restaurar período do localStorage se existir
    const periodoSalvo = localStorage.getItem('servicosNegativaPeriodo');
    if (periodoSalvo) {
      try {
        const periodo = JSON.parse(periodoSalvo);
        this.filtroDataInicio = periodo.inicio || this.getDataSeteDiasAtrasInput();
        this.filtroDataFim = periodo.fim || this.getDataHojeInput();
      } catch {
        this.filtroDataInicio = this.getDataSeteDiasAtrasInput();
        this.filtroDataFim = this.getDataHojeInput();
      }
    } else {
      this.filtroDataInicio = this.getDataSeteDiasAtrasInput();
      this.filtroDataFim = this.getDataHojeInput();
    }
    this.usuarioService.carregarTodosColaboradores().subscribe({
      next: (usuarios: any[]) => {
        this.usuariosFiltro = usuarios.map(u => ({ usuarioId: u.usuarioId, nome: u.nome }));
        this.aplicarFiltro();
        this.cdr.markForCheck();
        try { this.cdr.detectChanges(); } catch(e) { /* ignore if view not ready */ }
      },
      error: () => {
        this.usuariosFiltro = [];
        this.aplicarFiltro();
        this.cdr.markForCheck();
        try { this.cdr.detectChanges(); } catch(e) { /* ignore if view not ready */ }
      }
    });
  }

  aplicarFiltro(): void {
    // Persistir período no localStorage
    localStorage.setItem('servicosNegativaPeriodo', JSON.stringify({
      inicio: this.filtroDataInicio,
      fim: this.filtroDataFim
    }));
    this.carregando = true;
    this.spinner.show();
    this.erro = null;
    this.paginaAtual = 1;
    // Fecha o painel de filtros ao aplicar
    this.showFiltros = false;
    this.buscarNegativas();
    this.cdr.markForCheck();
    try { this.cdr.detectChanges(); } catch(e) { /* ignore if view not ready */ }
  }

  alterarTamanhoPagina(novoTamanho: number): void {
    this.tamanhoPagina = Number(novoTamanho) || this.tamanhoPagina;
    this.paginaAtual = 1;
    // Recarrega os dados com novo tamanho de página
    this.aplicarFiltro();
  }

  // Método usado pelo template para resetar filtros e recarregar
  resetarERecarregar(): void {
    this.resetarFiltro();
    // após resetar, recarrega usando aplicarFiltro para garantir dados paginados
    this.aplicarFiltro();
  }

  // Método para alternar filtros com detecção de mudança
  toggleFiltros(): void {
    this.showFiltros = !this.showFiltros;
    this.cdr.markForCheck();
  }

  buscarNegativas(): void {
    if (!this.filtroUsuarioId) {
      // Todos os usuários
      this.negativaService.obterTodos(
        this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined,
        this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined,
        this.paginaAtual,
        this.tamanhoPagina,
        'Negado'
      ).subscribe({
        next: (res) => {
          this.negativas = Array.isArray(res.itens) ? res.itens : [];
          this.totalItens = res.totalItens || this.negativas.length;
          this.totalPaginas = res.totalPaginas || 1;
          this.negativasFiltradas = this.negativas;
          this.aplicarFiltrosLocais();
          this.carregando = false;
          this.spinner.hide();
          // template update: mark + detect to force immediate render under OnPush
          this.cdr.markForCheck();
          try { this.cdr.detectChanges(); } catch(e) { /* ignore if view not ready */ }
        },
        error: () => {
          this.erro = 'Falha ao carregar as negativas.';
          this.carregando = false;
          this.spinner.hide();
          this.cdr.markForCheck();
          try { this.cdr.detectChanges(); } catch(e) { /* ignore if view not ready */ }
        }
      });
    } else {
      // Filtro por usuário
      const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
      const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;
      this.negativaService.obterTodosRegistrosPorPeriodo(
        this.filtroUsuarioId,
        dataInicio,
        dataFim,
        this.paginaAtual,
        this.tamanhoPagina,
        'Negado'
      ).subscribe({
        next: (res: any) => {
          const arr = res && Array.isArray(res.itens) ? res.itens : [];
          this.negativas = arr;
          this.totalItens = res.totalItens || this.negativas.length;
          this.totalPaginas = res.totalPaginas || Math.ceil(this.totalItens / this.tamanhoPagina) || 1;
          this.paginaAtual = 1;
          this.negativasFiltradas = [...this.negativas.slice(0, this.tamanhoPagina)];
          this.aplicarFiltrosLocais();
          this.erro = null;
          this.carregando = false;
           this.spinner.hide();
          this.cdr.markForCheck();
          try { this.cdr.detectChanges(); } catch(e) { /* ignore if view not ready */ }
        },
        error: (err) => {
          let msg = '';
          if (err?.error) {
            if (typeof err.error === 'string') {
              msg = err.error;
            } else if (err.error.message) {
              msg = err.error.message;
            }
          } else if (err?.message) {
            msg = err.message;
          }
          if (msg && msg.toLowerCase().includes('nenhuma negativa encontrada')) {
            this.negativas = [];
            this.negativasFiltradas = [];
            this.totalItens = 0;
            this.totalPaginas = 1;
            this.erro = null;
          } else {
            this.erro = 'Falha ao carregar as negativas.';
          }
          this.carregando = false;
          this.spinner.hide();
          this.cdr.markForCheck();
          try { this.cdr.detectChanges(); } catch(e) { /* ignore if view not ready */ }
        }
      });
    }
  }

  resetarFiltro(): void {
  this.filtroUsuarioId = '';
  this.filtroDataInicio = this.getDataSeteDiasAtrasInput();
  this.filtroDataFim = this.getDataHojeInput();
  // Limpar período salvo no localStorage
  localStorage.removeItem('servicosNegativaPeriodo');
    this.tamanhoPagina = 50; // Reset page size to default
    this.paginaAtual = 1; // Reset to first page
    this.negativas = [];
    this.negativasFiltradas = [];
    this.erro = null;
    // reset filtros avancados
    this.showFiltros = false;
    this.filtroStatus = '';
    this.filtroNumeroOrdem = null;
    this.filtroMatricula = '';
    this.filtroNomeConsumidor = '';
    this.filtroCpf = '';
    this.filtroCnpj = '';
    this.filtroCep = '';
    this.filtroLogradouro = '';
    this.filtroBairro = '';
    this.filtroCidade = '';
    this.filtroEstado = '';
    this.filtroNumero = '';
    this.filtroNumeroVistoria = '';
  }

  private aplicarFiltrosLocais(): void {
    if (!this.negativas || this.negativas.length === 0) {
      this.negativasFiltradas = [];
      return;
    }

    const statusFiltro = (this.filtroStatus || '').toString().trim().toLowerCase();
    const numOrdemFiltro = this.filtroNumeroOrdem;
    const matriculaFiltro = (this.filtroMatricula || '').toString().trim().toLowerCase();
    const nomeFiltro = (this.filtroNomeConsumidor || '').toString().trim().toLowerCase();
    const numeroFiltro = (this.filtroNumeroVistoria || '').toString().trim().toLowerCase();

    this.negativasFiltradas = this.negativas.filter(s => {
      // status
      if (statusFiltro) {
        // Check both 'status' and 'statusOS' (and effectiveStatus) so local filtering matches server behaviour
        const sStatus = (s.status || '').toString().toLowerCase();
        const sStatusOS = (s.statusOS || s.statusOs || s.status_os || '').toString().toLowerCase();
        const eff = (this.effectiveStatus(s) || '').toString().toLowerCase();
        if (!(sStatus.includes(statusFiltro) || sStatusOS.includes(statusFiltro) || eff.includes(statusFiltro))) return false;
      }

      // numero da ordem (aceita campo numeroOrdem, numeroOrdemFormatado ou ordemNumero)
      if (numOrdemFiltro !== null && numOrdemFiltro !== undefined && numOrdemFiltro !== 0) {
        const candidatos = [s.numeroOrdem, s.numeroOrdemFormatado, s.ordemNumero, s.numero];
        const encontrado = candidatos.some((c: any) => c !== undefined && c !== null && c.toString().indexOf(numOrdemFiltro.toString()) !== -1);
        if (!encontrado) return false;
      }

      // matricula
      if (matriculaFiltro) {
        const sMat = (s.matricula || s.matriculaConsumidor || s.matriculaUsuario || '').toString().toLowerCase();
        if (!sMat.includes(matriculaFiltro)) return false;
      }

      // nome consumidor
      if (nomeFiltro) {
        const sNome = (s.nomeConsumidor || s.nome || '').toString().toLowerCase();
        if (!sNome.includes(nomeFiltro)) return false;
      }

      // numero (Nº Vistoria) - comparar com varios campos incluindo numeroOS
      if (numeroFiltro) {
        const candidatosNumero = [
          s.numeroOS, s.numeroOs, s.numeroOrdemFormatado, s.numeroOrdem, s.numero, s.ordemNumero
        ];

        const numeroFiltroSemZeros = numeroFiltro.replace(/^0+/, '');

        const encontradoNumero = candidatosNumero.some((c: any) => {
          if (c === undefined || c === null) return false;
          const cs = c.toString().toLowerCase();
          // comparar tanto com zeros quanto sem zeros à esquerda
          if (cs.includes(numeroFiltro)) return true;
          if (cs.replace(/^0+/, '').includes(numeroFiltroSemZeros)) return true;
          return false;
        });

        if (!encontradoNumero) return false;
      }

      return true;
    });
  }

  // Formata o número da OS/vistoria (tenta vários campos possíveis)
  formatNumeroOS(item: any): string {
    if (!item) return '-';
    const candidato = item.numeroOS || item.numeroOs || item.numeroOrdem || item.numero || item.ordemNumero || item.numeroOrdemFormatado || item.osNumero || item.osNumero1 || item.osNumero2 || item.osNumero3;
    if (candidato === undefined || candidato === null || candidato === '') return '-';
    const s = candidato.toString();
    // Se contém caracteres não numéricos ou já tem formatação, retorna tal qual
    if (/[^0-9]/.test(s) || /^0+/.test(s)) return s;
    // Pad para 4 dígitos (ex: 14 -> 0014)
    return s.padStart(4, '0');
  }

  verDetalhes(negativa: any): void {
    const isTV = this.deviceService.isTV();
    const ZERO_UUID = '00000000-0000-0000-0000-000000000000';
    const isRecadastro = this.getTipoServico(negativa) === 'recadastro';

    if (isTV) {
      let idParaBuscar = '';
      if (isRecadastro) {
        idParaBuscar = negativa.recadastroId && negativa.recadastroId !== ZERO_UUID
          ? negativa.recadastroId
          : negativa.id;
      } else {
        idParaBuscar = negativa.cadastroId && negativa.cadastroId !== ZERO_UUID
          ? negativa.cadastroId
          : negativa.id;
      }
      if (!idParaBuscar || idParaBuscar === ZERO_UUID) {
        console.warn('[TV] Nenhum ID válido encontrado para negativa:', negativa);
        return;
      }
      this.spinner.show();
      const serviceCall = isRecadastro
        ? this.servicoService.obterRecadastroPorId(idParaBuscar)
        : this.servicoService.obterCadastroPorId(idParaBuscar);
      serviceCall.subscribe({
        next: (detalhes: any) => {
          const queryParams: any = {};
          if (detalhes?.usuarioId) {
            queryParams.usuarioId = detalhes.usuarioId;
          }
          const idJuncao = detalhes?.idJuncao || detalhes?.IdJuncao || detalhes?.idjuncao || detalhes?.idJuncaoFk;
          if (idJuncao && idJuncao !== ZERO_UUID) {
            queryParams.idJuncao = idJuncao;
            this.servicoService.obterDetalhesporIdJuncao(idJuncao).subscribe({
              next: (detalhesCompletos: any) => {
                const dataEvento = detalhesCompletos?.dataHoraInicio || detalhes?.dataHoraInicio;
                if (dataEvento) {
                  const day = new Date(dataEvento).toISOString().split('T')[0];
                  queryParams.filtroDataInicio = `${day}T00:00:00`;
                  queryParams.filtroDataFim = `${day}T23:59:59`;
                }
                if (detalhesCompletos?.recadastroId || detalhes?.recadastroId) {
                  queryParams.recadastroId = detalhesCompletos?.recadastroId || detalhes?.recadastroId;
                } else if (detalhesCompletos?.cadastroId || detalhes?.cadastroId) {
                  queryParams.cadastroId = detalhesCompletos?.cadastroId || detalhes?.cadastroId;
                }
                this.ngZone.run(() => {
                  this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
                    .finally(() => this.spinner.hide());
                });
              },
              error: (err: any) => {
                console.error('[TV] Erro ao buscar detalhes por idJuncao', err);
                const dataEvento = detalhes?.dataHoraInicio;
                if (dataEvento) {
                  const day = new Date(dataEvento).toISOString().split('T')[0];
                  queryParams.filtroDataInicio = `${day}T00:00:00`;
                  queryParams.filtroDataFim = `${day}T23:59:59`;
                }
                if (detalhes?.recadastroId) {
                  queryParams.recadastroId = detalhes.recadastroId;
                } else if (detalhes?.cadastroId) {
                  queryParams.cadastroId = detalhes.cadastroId;
                }
                this.ngZone.run(() => {
                  this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
                    .finally(() => this.spinner.hide());
                });
              }
            });
            return;
          }
          // Se não tem idJuncao, navega com os dados disponíveis
          const dataEvento = detalhes?.dataHoraInicio;
          if (dataEvento) {
            const day = new Date(dataEvento).toISOString().split('T')[0];
            queryParams.filtroDataInicio = `${day}T00:00:00`;
            queryParams.filtroDataFim = `${day}T23:59:59`;
          }
          if (detalhes?.recadastroId) {
            queryParams.recadastroId = detalhes.recadastroId;
          } else if (detalhes?.cadastroId) {
            queryParams.cadastroId = detalhes.cadastroId;
          }
          this.ngZone.run(() => {
            this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
              .finally(() => this.spinner.hide());
          });
        },
        error: (err: any) => {
          console.error('[TV] Erro ao buscar detalhes do serviço', err);
          this.spinner.hide();
        }
      });
      return;
    }
    // ...comportamento padrão (modal)
    this.carregando = true;
    this.spinner.show();
    this.negativaDetalhes = null;
    if (isRecadastro && negativa.recadastroId) {
      this.servicoService.obterRecadastroPorId(negativa.recadastroId).subscribe({
        next: (res: any) => {
          this.negativaDetalhes = res || negativa;
          this.carregando = false;
          this.spinner.hide();
          this.cdr.markForCheck();
          try { this.cdr.detectChanges(); } catch(e) { /* ignore if view not ready */ }
          setTimeout(() => this.inicializarMapaNegativa(), 350);
        },
        error: () => {
          this.negativaDetalhes = negativa;
          this.carregando = false;
          this.spinner.hide();
          this.cdr.markForCheck();
          setTimeout(() => this.inicializarMapaNegativa(), 350);
        }
      });
      return;
    }
    if (!isRecadastro && negativa.cadastroId) {
      this.servicoService.obterCadastroPorId(negativa.cadastroId).subscribe({
        next: (res: any) => {
          this.negativaDetalhes = res || negativa;
          this.carregando = false;
          this.spinner.hide();
          this.cdr.markForCheck();
          setTimeout(() => this.inicializarMapaNegativa(), 350);
        },
        error: () => {
          this.negativaDetalhes = negativa;
          this.carregando = false;
          this.spinner.hide();
          this.cdr.markForCheck();
          setTimeout(() => this.inicializarMapaNegativa(), 350);
        }
      });
      return;
    }
    this.negativaDetalhes = negativa;
    this.carregando = false;
    this.spinner.hide();
    this.cdr.markForCheck();
    setTimeout(() => this.inicializarMapaNegativa(), 350);
  }

  trackByNegativa(index: number, item: any): any {
    return item && (item.negativaId || item.id || item.servicoId) ? (item.negativaId || item.id || item.servicoId) : index;
  }

  inicializarMapaNegativa(): void {

    if ((window as any)._mapNegativa) {
      (window as any)._mapNegativa.remove();
      (window as any)._mapNegativa = null;
    }

    const latInicio = this.negativaDetalhes?.latitudeInicio;
    const lngInicio = this.negativaDetalhes?.longitudeInicio;
    const latFim = this.negativaDetalhes?.latitudeFim;
    const lngFim = this.negativaDetalhes?.longitudeFim;
    const divMapa = document.getElementById('map-cadastro');

    if (!divMapa) {
      console.error('Elemento map-cadastro não encontrado');
      return;
    }

    divMapa.innerHTML = '';
    divMapa.style.height = '220px';
    divMapa.style.width = '100%';

    // Só mostra o mapa se pelo menos um ponto existir
    if (latInicio && lngInicio || latFim && lngFim) {
      try {
        const map = L.map('map-cadastro').setView([latInicio || latFim, lngInicio || lngFim], 15);
        // armazenar referência consistente para remoção posterior
        (window as any)._mapNegativa = map;

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© OpenStreetMap'
        }).addTo(map);

        // Marcador início (azul)
        if (latInicio && lngInicio) {
          const inicioIcon = L.icon({
            iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoInicio.png',
            iconSize: [48, 48],
            iconAnchor: [24, 48],
            popupAnchor: [0, -45]
          });
          L.marker([latInicio, lngInicio], { icon: inicioIcon }).addTo(map).bindPopup('Início da Vistoria');
        }

        // Marcador fim (vermelho)
        if (latFim && lngFim) {
          const fimIcon = L.icon({
            iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoFim.png',
            iconSize: [48, 48],
            iconAnchor: [24, 48],
            popupAnchor: [0, -45]
          });
          L.marker([latFim, lngFim], { icon: fimIcon }).addTo(map).bindPopup('Fim da Vistoria');
        }

        // Se existem ambos os pontos, ajustar a visualização para mostrar ambos
        if (latInicio && lngInicio && latFim && lngFim) {
          const bounds = L.latLngBounds([
            [latInicio, lngInicio],
            [latFim, lngFim]
          ]);
          map.fitBounds(bounds, { padding: [20, 20] });
        }

      } catch (error) {
        console.error('Erro ao inicializar mapa:', error);
        divMapa.innerHTML = '<div class="d-flex align-items-center justify-content-center h-100 text-muted"><i class="bi bi-exclamation-triangle me-2"></i>Erro ao carregar mapa</div>';
      }
    } else {
      divMapa.innerHTML = '<div class="d-flex align-items-center justify-content-center h-100 text-muted"><i class="bi bi-geo-alt-slash me-2"></i>Coordenadas não disponíveis</div>';
    }
  }


  fecharModalDetalhes(): void {
    this.negativaDetalhes = null;
    // Remove mapa do modal
    if ((window as any)._mapNegativa) {
      (window as any)._mapNegativa.remove();
      (window as any)._mapNegativa = null;
    }
  }

  irParaPagina(pagina: number): void {
    if (pagina >= 1 && pagina <= this.totalPaginas && pagina !== this.paginaAtual) {
      this.paginaAtual = pagina;
      // Ao mudar de página, busca novamente do backend com os filtros atuais
      this.buscarNegativas();
    }
  }

  paginaAnterior(): void {
    if (this.paginaAtual > 1) {
      this.irParaPagina(this.paginaAtual - 1);
    }
  }

  proximaPagina(): void {
    if (this.paginaAtual < this.totalPaginas) {
      this.irParaPagina(this.paginaAtual + 1);
    }
  }

  obterPaginas(): number[] {
    const paginas = [];
    const maxPaginasVisiveis = 5;
    const metade = Math.floor(maxPaginasVisiveis / 2);
    let inicio = Math.max(1, this.paginaAtual - metade);
    let fim = Math.min(this.totalPaginas, inicio + maxPaginasVisiveis - 1);
    if (fim - inicio < maxPaginasVisiveis - 1) {
      inicio = Math.max(1, fim - maxPaginasVisiveis + 1);
    }
    for (let i = inicio; i <= fim; i++) {
      paginas.push(i);
    }
    return paginas;
  }

  getDataHojeInput(): string {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  }

  getDataSeteDiasAtrasInput(): string {
    const hoje = new Date();
    const seteDiasAtras = new Date(hoje);
    // Subtract 7 days so the period covers the last 7 days up to today (inclusive)
    seteDiasAtras.setDate(hoje.getDate() - 0);
    return seteDiasAtras.toISOString().split('T')[0];
  }

  getImagemUrl(url: string): string {
    return this.negativaService.getImagemUrl(url);
  }
  onFiltroDataFimChange(): void {
    // If no end date selected, do nothing (user may be clearing the filter)
    if (!this.filtroDataFim) {
      return;
    }
    // Persistir período no localStorage ao alterar data fim
    localStorage.setItem('servicosNegativaPeriodo', JSON.stringify({
      inicio: this.filtroDataInicio,
      fim: this.filtroDataFim
    }));
    // Allow the ngModel binding to settle, then apply the filter.
    setTimeout(() => {
      try {
        this.aplicarFiltro();
      } catch (e) {
        // swallow to avoid breaking UI; spinner/error handling is inside aplicarFiltro
        console.error('Erro ao aplicar filtro automaticamente por data fim', e);
      }
    }, 50);
  }
  abrirModalFoto(url: string): void {
    this.fotoSelecionada = url || '';
    // Load saved rotation for this photo (if any)
    this.rotacaoFoto = this.getPhotoRotation(url);
    this.mostrarModalFoto = true;
  }

  /** Rotate a photo by delta degrees (e.g. 90 or -90). Uses URL as key. */
  rotatePhoto(url: string | undefined, delta: number): void {
    if (!url) return;
    const key = this.getFotoRotacaoKey(url);
    const current = this.photoRotations[key] ?? this.loadRotationFromStorage(key) ?? 0;
    // normalize delta to multiples of 90
    const normalized = Math.round(delta / 90) * 90;
    let next = (current + normalized) % 360;
    if (next < 0) next += 360;
    this.photoRotations[key] = next;
    this.saveRotationToStorage(key, next);
    // if modal is showing this photo, update rotacaoFoto
    if (this.mostrarModalFoto && this.fotoSelecionada === url) {
      this.rotacaoFoto = next;
    }
  }

  /** Returns current rotation for an image URL (degrees) */
  getPhotoRotation(url: string | undefined): number {
    if (!url) return 0;
    const key = this.getFotoRotacaoKey(url);
    return this.photoRotations[key] ?? this.loadRotationFromStorage(key) ?? 0;
  }

  getFotoRotacaoKey(url: string): string {
    const prefix = 'negativa_foto_rotacao:';
    if (!url) return prefix + 'undefined';
    // Normalize to full URL so saved keys match regardless of whether callers pass a relative or full URL
    const full = this.getFullImageUrl(url);
    return prefix + full;
  }

  private saveRotationToStorage(key: string, value: number): void {
    try {
      localStorage.setItem(key, value.toString());
    } catch (e) {
      // ignore storage errors
    }
  }

  private loadRotationFromStorage(key: string): number | null {
    try {
      const v = localStorage.getItem(key);
      return v ? parseInt(v, 10) : null;
    } catch (e) {
      return null;
    }
  }

  fecharModalFoto(): void {
    this.mostrarModalFoto = false;
    this.fotoSelecionada = '';
    this.rotacaoFoto = 0;
  }
  maskCpf(cpf: string): string {
    if (!cpf) return '';
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return cpf;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  maskCnpj(cnpj: any): string {
    if (!cnpj) return '';
    cnpj = String(cnpj).replace(/\D/g, '');
    if (cnpj.length !== 14) return cnpj;
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  maskTelefone(telefone: string): string {
    if (!telefone) return '';
    telefone = telefone.replace(/\D/g, '');
    if (telefone.length === 11) {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    if (telefone.length === 10) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return telefone;
  }
  getFullImageUrl(url: string): string {
    if (!url) return '';
    if (/^https?:\/\//.test(url)) return url;
    // Remove barra duplicada
    const base = environment.mediaUrl.replace(/\/$/, '');
    const path = url.startsWith('/') ? url : '/' + url;
    return base + path;
  }

  getUsuarioNome(usuarioId: string): string {
    if (!usuarioId) return '-';
    const usuario = this.usuariosFiltro.find((u: any) => u.usuarioId === usuarioId);
    return usuario ? usuario.nome : '-';
  }
  getTipoServico(item: any): string {
    if (item.recadastroId && item.recadastroId !== "00000000-0000-0000-0000-000000000000") {
      return 'recadastro';
    }
    return 'cadastro';
  }

  getDataServico(item: any): string {
    if (this.getTipoServico(item) === 'recadastro') {
      return item.dataRecadastramento || '-';
    }
    return item.dataCadastro || '-';
  }
  exportarServicoParaPDF(): void {
    if (!this.negativaDetalhes) return;

    // Salva os dados do serviço antes de fechar o modal
    const dadosServico = { ...this.negativaDetalhes };

    // Busca o modal-body original
    const modalBodyOriginal = document.querySelector('.modal-body') as HTMLElement;
    if (!modalBodyOriginal) return;

    // Cria um clone do modal-body para captura
    const modalBodyClone = modalBodyOriginal.cloneNode(true) as HTMLElement;

    // Configura o clone para captura completa mas visível para html2canvas
    modalBodyClone.style.position = 'absolute';
    modalBodyClone.style.top = '-9999px';
    modalBodyClone.style.left = '-9999px';
    modalBodyClone.style.overflow = 'visible';
    modalBodyClone.style.maxHeight = 'none';
    modalBodyClone.style.height = 'auto';
    modalBodyClone.style.width = modalBodyOriginal.offsetWidth + 'px';
    modalBodyClone.style.visibility = 'visible';
    modalBodyClone.style.pointerEvents = 'none';
    modalBodyClone.style.opacity = '1';

    // Adiciona o clone ao body temporariamente
    document.body.appendChild(modalBodyClone);

    // Fecha o modal imediatamente para melhor UX
    this.fecharModalDetalhes();

    // Aguarda um momento para o clone renderizar completamente
    setTimeout(() => {
      html2canvas(modalBodyClone, {
        useCORS: true,
        allowTaint: true,
        scale: 2,
        logging: false,
        height: modalBodyClone.scrollHeight,
        width: modalBodyClone.scrollWidth
      }).then((canvas: any) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');

        const imgWidth = 210;
        const pageHeight = 295;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        const nomeConsumidor = dadosServico.nomeConsumidor || 'Sem_Nome';
        const dataServico = dadosServico.dataServico ?
          new Date(dadosServico.dataServico).toLocaleDateString('pt-BR').replace(/\//g, '-') :
          new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');

        const nomeArquivo = `Servico_Pendente_${nomeConsumidor}_${dataServico}.pdf`;
        pdf.save(nomeArquivo);

        // Remove o clone
        document.body.removeChild(modalBodyClone);
      }).catch(() => {
        document.body.removeChild(modalBodyClone);
      });
    }, 500);
  }

  getEnderecoCompleto(item: any): string {
    if (!item) return '-';

    // Verifica se tem endereço como objeto
    const endereco = item.endereco || item;

    const partes = [];

    if (endereco.logradouro) {
      partes.push(endereco.logradouro);
    }
    if (endereco.numero) {
      partes.push(endereco.numero);
    }
    if (endereco.bairro) {
      partes.push(endereco.bairro);
    }
    if (endereco.cidade) {
      partes.push(endereco.cidade);
    }
    if (endereco.estado) {
      partes.push(endereco.estado);
    }

    return partes.length > 0 ? partes.join(', ') : '-';
  }

  effectiveStatus(servico: any): string {
    if (!servico) return '';
    const statusRaw = (servico.status || '').toString();
    const status = statusRaw.toLowerCase();
    const statusOS = (servico.statusOS || servico.statusOs || servico.status_os || '').toString();

    // Se status indica um dos casos em que devemos priorizar o próprio status:
    if (['analisando', 'validado', 'invalido'].includes(status)) {
      return statusRaw;
    }

    if (statusOS) return statusOS;

    return statusRaw || '';
  }
}
